/// <reference path="../../../app.definition.ts" />
interface IConfirmTooltipScope extends ng.IScope {
  confirmTooltipVm: EcvConfirmTooltip;
}

class EcvConfirmTooltip {
  timer: number;
  static $inject = ["$scope", "$timeout", "$compile"];
  flag: boolean;
  showTooltip: any;
  checkFn: any;
  outerClass: string;

  constructor($scope: IConfirmTooltipScope, $timeout: ng.ITimeoutService, $compile: ng.ICompileService) {
    const confirmTooltipVm = this;
    confirmTooltipVm.flag = false;
    $timeout(() => {
      const container = $(confirmTooltipVm.outerClass);
      container.click((e) => {
        if (!e.target.classList.contains("tooltip-link")) {
          if (!!confirmTooltipVm.flag) {
            $timeout(() => {
              $scope.$apply(() => {
                confirmTooltipVm.flag = false;
              });
            }, 5);
          }
        }
      });

      const tooltipLink = $('.tooltip-link');
      tooltipLink.click((e) => {
        angular.element('.tooltip-link').each(function () {
          if (!($(this).is($(e.target).parent()[0]) || $(this).is($(e.target)))) {
            const otherScope = $(this).scope() as IConfirmTooltipScope;
            if (otherScope && otherScope.confirmTooltipVm) {
              otherScope.confirmTooltipVm.flag = false;
            }
          }
        });
      });

    }, 100);
  }

  clickItem = (event) => {
    const setFlag = () => {
      if (!!this.showTooltip && !this.flag) {
        event.preventDefault();
        event.stopPropagation();
        clearTimeout(this.timer);
        this.flag = true;
        this.timer = window.setTimeout(() => {
          this.flag = false;
        }, 10000);
      }
    }
    if (!this.checkFn) {
      setFlag();
    } else if (this.checkFn) {
      this.checkFn().then(s => {
        setFlag();
      })
    }
  }
}

function confirmTooltip(): ng.IDirective {
  return {
    restrict: 'A',
    replace: false,
    controller: EcvConfirmTooltip,
    controllerAs: 'confirmTooltipVm',
    scope: true,
    transclude: true,
    bindToController: {
      'showTooltip': '=?ecvShowTooltip',
      'tooltipMsg': '=ecvTooltipMsg',
      'outerClass': '=ecvOuterClass',
      'flag': '=ecvFlag',
      'appendToBody': '=?ecvAppendToBody',
      'extraTooltipClass': '=?ecvExtraTooltipClass',
      'elementClass': '=ecvElementClass',
      'checkFn': '=?ecvCheckFn'
    },
    templateUrl: function (elem, attrs) {
      if (attrs.ecvElementType == "button") {
        return 'app/common/directive/confirm-tooltip/templates/button-confirm-tooltip.directive.html';
      } else {
        return 'app/common/directive/confirm-tooltip/templates/confirm-tooltip.directive.html';
      }
    }
  }
}

angular.module('eCareVault.common.directives').directive('ecvConfirmTooltip', confirmTooltip);
